import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { UserPlus } from 'lucide-react';

const Register = () => {
  const [formData, setFormData] = useState({
    email: '',
    username: '',
    password: '',
    fullName: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await register(formData.email, formData.username, formData.password, formData.fullName);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container" data-testid="register-page">
      <div className="auth-card">
        <div className="auth-header">
          <UserPlus className="auth-icon" size={32} />
          <h2 className="auth-title">Create Account</h2>
          <p className="auth-subtitle">Join your Agency Command Center</p>
        </div>
        {error && <div className="auth-error" data-testid="register-error">{error}</div>}
        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-form-group">
            <label htmlFor="email" className="auth-label">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              className="auth-input"
              data-testid="email-input"
              placeholder="you@agency.com"
              required
            />
          </div>
          <div className="auth-form-group">
            <label htmlFor="username" className="auth-label">Username</label>
            <input
              type="text"
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              className="auth-input"
              data-testid="username-input"
              placeholder="yourusername"
              minLength="3"
              required
            />
          </div>
          <div className="auth-form-group">
            <label htmlFor="fullName" className="auth-label">Full Name (Optional)</label>
            <input
              type="text"
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              className="auth-input"
              data-testid="fullname-input"
              placeholder="John Doe"
            />
          </div>
          <div className="auth-form-group">
            <label htmlFor="password" className="auth-label">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="auth-input"
              data-testid="password-input"
              placeholder="••••••••"
              minLength="8"
              required
            />
            <p className="auth-hint">Minimum 8 characters</p>
          </div>
          <button 
            type="submit" 
            disabled={loading}
            className="auth-button"
            data-testid="register-button"
          >
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>
        <p className="auth-link-text">
          Already have an account? <Link to="/login" className="auth-link">Login here</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;
